import CapacityField from './CapacityField';

export default CapacityField;
